import React from "react";
import "./review.scss";
import axios from "axios";
import Config from "../common/Config";
import FormTitle from "../components/formTitle/FormTitle";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class OneSocketPatientReview extends Review {
  constructor(props) {
    super(props);

    this.sidePump = 71;

    this.state = {
      uOM: null,
      mPTToFloor: null,
      calfToFloor: null,
      calfCirc: null,
      ankleCirc: null,
      iTToFloor: null,
      thighToFloor: null,
      kCToFloor: null,
      thighCirc: null,
      kCCirc: null,
      socketFinish: [],
      otherPRS: [],
      pump: [],
      sidePumpPlacement: [],
      valvePlacement: [],
      backAlignmentButton: [],
      insertMaterial: [],
      prostheticHeight: [],
      shorten: [],
      extend: [],
      fredsLegsDesignName: [],
      oneSystem: [],
      pumpSerial: [],
      mountingPlate: [],
      linerInterface: null,
      linerSize: null,
      linerProfile: null,
      linerPartNumber: null,
      linerOptionCombinations: [],
      footType: null,
      footMaterial: null,
      footImpact: null,
      footPartNumber: null,
      includeFoot: null,
      includeLiner: null,
      footShell: null,
      linerQuantity: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      super.loadData();
      
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };

      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "calfToFloor",
            "calfCirc",
            "ankleCirc",
            "socketFinish",
            "otherPRS",
            "pump",
            "sidePumpPlacement",
            "valvePlacement",
            "backAlignmentButton",
            "insertMaterial",
            "prostheticHeight",
            "shorten",
            "extend",
            "iTToFloor",
            "thighToFloor",
            "kCToFloor",
            "thighCirc",
            "kCCirc",
            "fredsLegsDesignName",
            "oneSystem",
            "pumpSerial",
            "mountingPlate",
            "linerInterface",
            "linerSize",
            "linerProfile",
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "includeLiner",
            "linerQuantity",
            "footShell",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      
      let footPartNumber = (
        await axios.get(
          Config.baseApiUrl + "footPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let linerPartNumber = (
        await axios.get(
          Config.baseApiUrl + "linerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        uOM: fieldInputs.find((fi) => fi.fieldName === "uOM").fieldOptionName,
        mPTToFloor: fieldInputs.find((fi) => fi.fieldName === "mPTToFloor")
          .numericData,
        calfToFloor: fieldInputs.find((fi) => fi.fieldName === "calfToFloor")
          .numericData,
        calfCirc: fieldInputs.find((fi) => fi.fieldName === "calfCirc")
          .numericData,
        ankleCirc: fieldInputs.find((fi) => fi.fieldName === "ankleCirc")
          .numericData,
        iTToFloor: fieldInputs.find((fi) => fi.fieldName === "iTToFloor")
          .numericData,
        thighToFloor: fieldInputs.find((fi) => fi.fieldName === "thighToFloor")
          .numericData,
        kCToFloor: fieldInputs.find((fi) => fi.fieldName === "kCToFloor")
          .numericData,
        thighCirc: fieldInputs.find((fi) => fi.fieldName === "thighCirc")
          .numericData,
        kCCirc: fieldInputs.find((fi) => fi.fieldName === "kCCirc").numericData,
        socketFinish: fieldInputs.filter(
          (fi) => fi.fieldName === "socketFinish"
        ),
        otherPRS: fieldInputs.filter((fi) => fi.fieldName === "otherPRS"),
        pump: fieldInputs.filter((fi) => fi.fieldName === "pump"),
        sidePumpPlacement: fieldInputs.filter(
          (fi) => fi.fieldName === "sidePumpPlacement"
        ),
        valvePlacement: fieldInputs.filter(
          (fi) => fi.fieldName === "valvePlacement"
        ),
        backAlignmentButton: fieldInputs.filter(
          (fi) => fi.fieldName === "backAlignmentButton"
        ),
        insertMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "insertMaterial"
        ),
        prostheticHeight: fieldInputs.filter(
          (fi) => fi.fieldName === "prostheticHeight"
        ),
        mountingPlate: fieldInputs.filter(
          (fi) => fi.fieldName === "mountingPlate"
        ),
        shorten: fieldInputs.filter((fi) => fi.fieldName === "shorten"),
        extend: fieldInputs.filter((fi) => fi.fieldName === "extend"),
        fredsLegsDesignName: fieldInputs.filter(
          (fi) => fi.fieldName === "fredsLegsDesignName"
        ),
        oneSystem: fieldInputs.filter((fi) => fi.fieldName === "oneSystem"),
        pumpSerial: fieldInputs.filter((fi) => fi.fieldName === "pumpSerial"),

        linerSize: fieldInputs.find((fi) => fi.fieldName === "linerSize")?.fieldOptionName,
        linerProfile: fieldInputs.find((fi) => fi.fieldName === "linerProfile")?.fieldOptionName,
        linerInterface: fieldInputs.find((fi) => fi.fieldName === "linerInterface")?.fieldOptionName,
        linerPartNumber: linerPartNumber,
        footShell: fieldInputs.find((fi) => fi.fieldName === "footShell")?.fieldOptionName,
        footPartNumber: footPartNumber,
        footType: fieldInputs.find((fi) => fi.fieldName === "footType")?.fieldOptionName,
        footMaterial: fieldInputs.find((fi) => fi.fieldName === "footMaterial")?.fieldOptionName,
        footImpact: fieldInputs.find((fi) => fi.fieldName === "footImpact")?.fieldOptionName,
        linerQuantity:
        fieldInputs.find((fi) => fi.fieldName === "linerQuantity")?.numericData ??
        0,
        includeLiner: fieldInputs.find((fi) => fi.fieldName === "includeLiner")?.fieldOptionName === "Yes",
        includeFoot: fieldInputs.find((fi) => fi.fieldName === "includeFoot")?.fieldOptionName === "Yes",
      
      });
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    return axios.post(
      Config.baseApiUrl + "orders/" + this.props.formTypeId,
      null,
      config
    );
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div
          className={`reviewWrapper ${
            this.props.isBilateral ? "bilateralWrapper" : ""
          }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.name}
                  {this.props.isBilateral &&
                    " (Order " + this.props.orderNumber + ")"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  <div className="po">
                    <span>SSD:</span>
                    <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <h3>Patient Information</h3>
              <div className="patientInfo">
                <div className="infoBorder">
                  <div className="patientSubInfo">
                    <span>Patient ID:</span>
                    <p>{this.state.patientId}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Weight:</span>
                    <p>{this.state.weight}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Height:</span>
                    <p>{this.state.height}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Foot Size:</span>
                    <p>{this.state.footSize}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>K Level</span>
                    <p>{this.state.kLevel}</p>
                  </div>
                </div>

                <div className="info">
                  <div className="patientSubInfo">
                    <span>Amputation Level</span>
                    <p>{this.state.amputationLevel}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Amputation Side</span>
                    <p>{this.state.footDirection}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>PO#</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <div className="subDetail">
                <div className="detailWrapper">
                  <div>
                    <div className="detail">
                      <h4>Measurements</h4>
                      {this.props.formTypeId === 7 && (
                        <div className="detailContentWrapper">
                          <div className="">
                            <div className="content">
                              <span>IT to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.mPTToFloor
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>Thigh to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfToFloor
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>KC to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfCirc
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>Calf to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfToFloor
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.props.formTypeId === 8 && (
                        <div className="detailContentWrapper">
                          <div className="borderBotom">
                            <div className="content">
                              <span>IT to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.iTToFloor
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>Thigh to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.thighToFloor
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>KC to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.kCToFloor
                                )}
                              </p>
                            </div>
                            <div className="content">
                              <span>Calf to Floor:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfToFloor
                                )}
                              </p>
                            </div>
                          </div>
                          <div>
                            <div className="content">
                              <span>Mid Thigh:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.thighCirc
                                )}
                              </p>
                            </div>

                            <div className="content">
                              <span>KC:</span>
                              <p>
                                {this.imageMeasurementEntry(this.state.kCCirc)}
                              </p>
                            </div>

                            <div className="content">
                              <span>Largest Calf:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfCirc
                                )}
                              </p>
                            </div>

                            <div className="content">
                              <span>Largest Ankle:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.ankleCirc
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="detail">
                      <h4>One® System</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <p> {this.makeFieldOutput(this.state.oneSystem)}</p>
                        </div>
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Mounting Plates</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Material:</span>
                          <p>
                            {" "}
                            {this.makeFieldOutput(this.state.mountingPlate)}
                          </p>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div>
                    <div className="detail">
                      <h4>Socket Finish</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Default:</span>
                          <p>{this.makeFieldOutput(this.state.socketFinish)}</p>
                          <span>Skin Tone:</span>
                          <p>
                            {this.makeConditionalFieldOutput(
                              "Other PRS #",
                              this.state.otherPRS,
                              "stringData"
                            )}
                          </p>
                          <span>Decorative Lamination:</span>
                          <p>
                            {this.makeConditionalFieldOutput(
                              "Fred's Legs Design Name",
                              this.state.fredsLegsDesignName,
                              "stringData"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Prosthetic Height Adjustment</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>
                            {this.makeFieldOutput(this.state.prostheticHeight)}:
                          </span>
                          <p>
                            {this.makeConditionalFieldOutput(
                              "Amount",
                              this.state.shorten,
                              "numericData"
                            )}
                            {this.makeConditionalFieldOutput(
                              "Amount",
                              this.state.extend,
                              "numericData"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="msgInfo ">
                  <h3>Items sent in with socket</h3>
                  <p>{this.state.itemsSentIn}</p>
                </div>

                <div className="msgInfo ">
                  <h3>Other Notes</h3>
                  <p>{this.state.notes}</p>
                </div>
              </div>
            </div>
            
            {this.state.includeLiner && this.state.linerQuantity > 0 && (
              <div className="information">
                <h3>Liner Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Interface:</span>
                      <p>{this.state.linerInterface}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Profile:</span>
                      <p>{this.state.linerProfile}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Size:</span>
                      <p>{this.state.linerSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.linerPartNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Quantity:</span>
                      <p>{this.state.linerQuantity}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.state.includeFoot && (
              <div className="information">
                <h3>Foot Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Type:</span>
                      <p>{this.state.footType}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Material:</span>
                      <p>{this.state.footMaterial}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Impact Level:</span>
                      <p>{this.state.footImpact}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Foot Shell:</span>
                      <p>{this.state.footShell}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.footPartNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {!this.props.showOrderInfo && (
              <div className="information">
                <h3>Patient Measurement</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Bill to account:</span>
                      <p>{this.state.accountNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinic:</span>
                      <p>{this.state.clinicName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinician Name:</span>
                      <p>{this.state.prosthetistName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Email Address</span>
                      <p>{this.state.email}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Phone</span>
                      <p>{this.state.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom shippingInfo">
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 1:</span>
                      <p>{this.state.shippingAddress1}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 2:</span>
                      <p>{this.state.shippingAddress2}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>State:</span>
                      <p>{this.state.stateName}</p>
                      <span>City:</span>
                      <p>{this.state.city}</p>
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Zip Code:</span>
                      <p>{this.state.zip}</p>
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.getNavButtons(this.props.uniqueId)}
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }
  
    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
}

export default OneSocketPatientReview;
